<template>
  <div class="content relative h-full">
    <div class="content__flex flex flex-col h-full">
      <ActionsToolbar />
      <NGrid class="h-full overflow-hidden mt-3" cols="12" item-responsive :x-gap="16">
        <NGridItem class="h-full overflow-auto" :span="'12 650:7 1200:8 1400:9'">
          <AllContent />
        </NGridItem>
        <NGridItem
          ref="sectionPanelRef"
          class="h-full overflow-auto max-h-[250px] md:max-h-[100%] bg-white"
          :span="'12 650:5 1200:4 1400:3'"
        >
          <SelectionPanel />
        </NGridItem>
      </NGrid>
    </div>
  </div>
</template>

<script setup lang="ts">
import { NGridItem, NGrid } from 'naive-ui'
import { onMounted, useTemplateRef } from 'vue'

import ActionsToolbar from '@content-selector/components/Content/ActionsToolbar/ActionsToolbar.vue'
import AllContent from '@content-selector/components/Content/AllContent/AllContent.vue'
import SelectionPanel from '@content-selector/components/Content/SelectionPanel/SelectionPanel.vue'
import { useStore } from '@content-selector/composables/useStore.ts'

const { setSectionPanelRef } = useStore()

const sectionPanelRef = useTemplateRef('sectionPanelRef')

onMounted(() => {
  setSectionPanelRef(sectionPanelRef.value?.$el ?? null)
})
</script>
